import React from 'react';

/**
 * The ONE place a check-in step number is rendered.
 *
 * Before this existed, six headers across five files each decided their own
 * number three different ways — hardcoded literals, a `const stepNumber = 3`
 * dressed up as a derivation, and a `retail ? 4 : 3` ternary that was simply
 * wrong (retail is a five-step wizard). `CheckInWizard` already computes
 * `currentStep` and `maxSteps` on every render; the steps just take them.
 *
 * Renders NOTHING when `stepNumber` is absent. That is how `VINStep` behaves
 * inside `VINRequiredModal`, which is a modal and not a wizard — it replaced a
 * suppress-the-header boolean prop that only one of VINStep's three render
 * branches actually honoured.
 *
 * "of {totalSteps}" is deliberate: the progress dots already show the total, so
 * printing it here is what makes a mismatch visible instead of silent.
 */
const CheckInStepHeader = ({ stepNumber, totalSteps, title }) => {
  if (!stepNumber) return null;
  return (
    <h4 className="text-center mb-4">
      Step {stepNumber} of {totalSteps}: {title}
    </h4>
  );
};

export default CheckInStepHeader;
